import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getEnrollment = async ({ studentId, courseId }) => {
  const res = await axios.middleware("/backend.asmx/BK_Matricula_Curso_Extra", {
    params: {
      alunoid: studentId,
      disciplinaid: courseId,
    },
  });
  return res[0].data[0];
};

export const useEnrollment = ({ config, params = {} } = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "courseEnrollment",
      { studentId: _cookies.getItem("auth").user.alunoid, ...params },
    ],
    queryFn: () =>
      getEnrollment({
        studentId: _cookies.getItem("auth").user.alunoid,
        ...params,
      }),
  });
};
